<script>
import Cookies from "js-cookie";
import {notificationMethods, advisorMethods,uploadMethods} from "@/state/helpers";
import {required} from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor';
import appConfig from "@/app.config";
import api from "@/helpers/axios";
export default {
  page: {
    title: "Advisors",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast,
    quillEditor,
  },
  data() {
    return {
      toastAction: '',
      toastMessage: '',
      showToast: false,
      itemsLoaded: false,
      items: [],
      sites: [],
      quillOptions: {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            ['link'],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            ['clean']
          ]
        }
      },
      currentUser: JSON.parse(Cookies.get('user')),
      advisors: [],
      title: "Akademik Danışmanlar Tablosu",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Akademik Danışmanlar",
        },
      ],
      addSubmitted: false,
      editSubmitted: false,
      showModal: false,
      editModal: false,
      deleteModal: false,
      noDeleteModal: false,
      formError: '',
      editFormError: '',
      addForm: {
        name: "",
        site: [],
        description: "",
        isActive: true,
        image:"",
      },
      editForm: {
        name: "",
        description: "",
        isActive: true,
      image:"",
        site: [],
      },
      editId: "",
      deleteId: "",
      totalRows: 1,
      page: 1,
      perPage: 10,
      search: '',
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "name",
          label:'Danışman Adı',
          sortable: true,
        },
        {
          key: "site",
          label:'Site',
          sortable: true,
        },
        {
          key: "isActive",
          label:'Aktiflik Durumu',
          sortable: true,
        },

        {
          key: "edit",
          label: "Düzenle",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      imgLoading:false,
      editImgLoading:false,
      pageInput: 1
    };
  },
  validations: {
    addForm: {
      name: {required},
      image: {required},
     site:{required},
      isActive: {required},
      description:{required},
    },
    editForm: {
      name: {required},
      image: {required},
    site:{required},
      isActive: {required},
      description:{required},
    },
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
    totalPages() {
      return Math.ceil(this.totalRows / this.perPage);
    },
  },
  watch: {
    page(newPage) {
      this.pageInput = newPage;
      this.getAdvisors(newPage);
    },
    search(newSearch) {
      if (newSearch.length < 1) {
        if (this.page === 1) {
          this.getAdvisors();
        } else {
          this.page = 1;
        }
      }
    },
    'addForm.email': function () {
      this.addForm.email = this.turkishToLower(this.addForm.email)
    },
    'editForm.email': function () {
      this.editForm.email = this.turkishToLower(this.editForm.email)
    }
  },
  mounted() {
    this.getAdvisors();
    this.fetchSites();
  },
  methods: {
    ...advisorMethods,
    ...notificationMethods,
    ...uploadMethods,
    updateImageUrl(url) {
      this.imageUrl = url;
    },
    onImageChange(e) {
      let files = e.target.files || e.data.transfer.files;
      if (!files.length)
        return;
      let data = new FormData()
      data.append('upload', files[0])
      data.append('folder', 'advisors')
      let addForm = this.addForm;
      this.imgLoading = true;
      this.uploadFile(data).then((res) => {
        addForm.image = res.url;
        this.imgLoading = false;
      })
    },
    resetForm() {
      this.addForm.name = null;
      this.addForm.site = [];
      this.addForm.description = null;
      this.addForm.isActive = true;
      this.addForm.image = null;
      //
      this.editForm.name = null;
      this.editForm.site = [];
      this.editForm.description = null;
      this.editForm.isActive = true;
      this.editForm.image = null;
      //
      this.addSubmitted = false;
      this.editSubmitted=false;
    },
    onEditImageChange(e) {
      let files = e.target.files || e.data.transfer.files;
      if (!files.length) return;

      let data = new FormData();
      data.append("upload", files[0]);
      data.append("folder", "advisors");
      let editForm = this.editForm;
      this.editImgLoading = true;
      this.uploadFile(data)
          .then((res) => {
            editForm.image = res.url;
            this.imageUrl = res.url;
            this.editImgLoading = false;
          });
      this.$v.editForm.image.$touch();
    },

    formatSite(site) {
      return site
    },
    async fetchSites() {
      try {
        const response = await api.get("/sites");
        this.sites = response.data.data.docs;
      } catch (error) {
        return
      }
    },

    doSearch() {
      if (this.page === 1) {
        this.getAdvisors();
      } else {
        this.page = 1;
      }
    },
    getAdvisors(page = this.page) {
      this.itemsLoaded = false;
      let filter = {}
      if (this.filter) {
        filter.name = this.filter;
      }
      this.fetchAdvisors({page, limit: this.perPage, search: this.search}).then(res => {
        this.totalRows = res.total;
        this.items = res.docs.map(elem=>{
          return elem;
        })
        this.itemsLoaded = true;
      })
    },

    handleSubmit() {
      this.addSubmitted = true;
      this.formError = "";
      this.$v.addForm.$touch();

      if (this.$v.addForm.$invalid) {
        return;
      } else {
        const isActive = this.addForm.isActive ? "true" : "false";
        const postData = {
          ...this.addForm,
          site: this.addForm.site,
          isActive,
        };
        this.createAdvisor(postData)
            .then(() => {
              this.toastMessage = "Danışman başarıyla eklendi!";
              this.toastAction = "success";
              this.showToast = true;
              setTimeout(() => {
                this.showToast = false;
              }, 3000);
              this.showModal = false;
              this.getAdvisors();
              this.addForm.name = "";
              this.addForm.image = "";
              this.addForm.site = "";
              this.addForm.isActive = false;
              this.addForm.description = "";
            })
            .catch((err) => {
              if (err == 'TCNUMBER_ALREADY_USE') {
                this.formError = "Girilen TC numarasına sahip bir Danışman bulunmaktadır.";
              } else {
                this.toastMessage = "Sistemde bir hata oluştu!";
                this.toastAction = "error";
                this.showToast = true;
                setTimeout(() => {
                  this.showToast = false;
                }, 3000);
              }
            });
      }
    },
    handleEditSubmit() {
      this.editSubmitted = true;
      this.editFormError = ""
      this.$v.editForm.$touch();
      if (
          this.$v.editForm.$invalid
      ) {
        return;
      } else {
        const isActive = this.editForm.isActive ? "true" : "false";
        const editData = {
          id: this.editId,
          data: {
            ...this.editForm,
            site: this.editForm.site,

            isActive
          },
        };
        this.updateAdvisor(editData).then(() => {
          this.toastMessage = "Danışman başarıyla düzenlendi!";
          this.toastAction = "success";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
          this.editModal = false;
          this.getAdvisors();
          this.editForm.name = "";
          this.editForm.site = "";
          this.editForm.description = "";
        //  this.editForm.image = "";
        }).catch((err) => {
          if (err == 'TCNUMBER_ALREADY_USE') {
            this.editFormError = "Girilen TC numarasına sahip bir Danışman bulunmaktadır."
          } else {
            this.toastMessage = "Sistemde bir hata oluştu!";
            this.toastAction = "error";
            this.showToast = true;
            setTimeout(() => {
              this.showToast = false;
            }, 3000)
          }
        })
      }
    },
    handleDeleteSubmit() {
      this.deleteAdvisor(this.deleteId).then(() => {
        this.deleteModal = false;
        this.toastMessage = "Danışman başarıyla silindi!";
        this.toastAction = "success";
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 3000)
        this.getAdvisors();
      })
    },
    openEdit(advisor) {
      this.editId = advisor.id;
      this.editModal = true;
      this.editForm = {
        name : advisor.name,
        description : advisor.description,
        isActive :advisor.isActive,
        site : advisor.site.map(site => site._id),
        image: advisor.image
      };
      this.updateImageUrl(advisor.image);
    },

    openDelete(advisor) {
      if (advisor.email === this.currentUser.email) {
        this.noDeleteModal = true;
      } else {
        this.deleteId = advisor.id;
        this.deleteModal = true;
      }
    },
    turkishToLower(str) {
      let letters = {"İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç"};
      str = str.replace(/(([İIŞĞÜÇÖ]))+/g, function (letter) {
        return letters[letter];
      })
      return str.toLowerCase();
    }
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems"/>
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Ara:
                    <b-form-input
                        v-model="search"
                        @keyup.enter="doSearch"
                        type="search"
                        placeholder="ara..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>

                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="showModal = true; resetForm();"
                >
                  Danışman Ekle
                </button>
              </div>
            </div>

            <!-- Table -->
            <div v-if="itemsLoaded">
              <div class="table-responsive mb-0">
                <b-table
                    class="datatables"
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                >
                  <template v-slot:cell(createdAt)="data">
                    {{ new Date(data.item.createdAt).toDateString() }}
                  </template>
                  <template v-slot:cell(isActive)="data">
 <span class="badge badge-pill font-size-14" :class="{ 'badge-soft-success': data.item.isActive, 'badge-soft-danger': !data.item.isActive }">
    <span>{{ data.item.isActive ? 'Aktif' : 'Pasif' }}</span>
  </span>
                  </template>
                  <template v-slot:cell(site)="data">
                    <ul>
                      <li v-for="site in data.item.site" :key="site.id">{{ site.name }}</li>
                    </ul>
                  </template>
                  <template v-slot:cell(detail)="data">
                    <button
                        class="btn btn-info d-flex py-2"
                        @click="$router.push({name:'advisorDetail',params:{advisorId: data.item.id}})"
                    >
                      <i :class="`bx bxs-detail bx-xs`"></i>
                    </button>
                  </template>
                  <template v-slot:cell(edit)="data">
                    <button
                        class="btn btn-warning d-flex py-2"
                        @click="openEdit(data.item)"
                    >
                      <i :class="`bx bxs-edit bx-xs`"></i>
                    </button>
                  </template>
                  <template v-slot:cell(delete)="data">
                    <button
                        :disabled="currentUser.role.includes('user')"
                        class="btn btn-danger d-flex py-2"
                        @click="openDelete(data.item)"
                    >
                      <i :class="`bx bx-trash bx-xs`"></i>
                    </button>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="spinner-wrapper" v-else>
              <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <input :style="{width:'50px'}" @keyup.enter="page=pageInput" v-model="pageInput" type="text"
                           class="form-control">
                    <b-pagination
                        v-model="page"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
                <div class="page-info mt-2"> Toplam sayfa sayısı {{ totalPages }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal size="lg" v-model="showModal" title="Danışman Ekle" hide-footer>
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label for="name">Danışman Adı</label>
                <input
                    id="name"
                    type="text"
                    v-model="addForm.name"
                    class="form-control"
                    placeholder="Danışman adı giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.name.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.name.required"
                    class="invalid-feedback"
                >
                  Danışman Adı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label class="me-2" :class="{
                    'is-invalid': addSubmitted && $v.addForm.site.$error,
                  }">Site Seçiniz</label>
                <div class="checkbox-group">
                  <label v-for="site in sites" :key="site.id" class="me-3">
                    <input
                        type="checkbox"
                        :id="`site_${site.id}`"
                        :value="site.id"
                        v-model="addForm.site"
                        class="form-check-input"
                    />
                    <label :for="`site_${site.id}`" class="form-check-label ms-1">{{ site.name }}</label>
                  </label>

                </div>
                <div
                    v-if="addSubmitted && !$v.addForm.site.required"
                    class="invalid-feedback"
                >
                  Site seçilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12 mb-2">
              <div class="mb-3"  :class="{
                    'is-invalid': addSubmitted && $v.addForm.description.$error,
                  }">
                <label for="description">Danışman Bilgileri</label>
                <quill-editor
                    v-model="addForm.description"
                    ref="quillEditor"
                    :options="quillOptions"
                ></quill-editor>
              </div>
              <div
                  v-if="addSubmitted && !$v.addForm.description.required"
                  class="invalid-feedback" style="margin-top:-6px"
              >
                Danışman Bilgileri girilmesi gerekli bir alandır.
              </div>
            </div>
            <div class="col-12 mt-1">
              <div class="mb-3">
                <label for="image" class="form-label">Danışman Resmi</label>

                <input
                    type="file"
                    id="image"
                    @change="onImageChange"
                    accept="image/*"
                    class="form-control"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.image.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.image.required"
                    class="invalid-feedback"
                >
                  Resim girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="isActive" class="me-2">Durum</label>
                <input
                    id="isActive"
                    type="checkbox"
                    v-model="addForm.isActive"
                    class="form-check-input"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.isActive.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.isActive.required"
                    class="invalid-feedback"
                >
                  Danışman Bilgileri girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div
                v-if="formError.length>0"
                class="text-danger d-flex justify-content-end"
            >
              <p>{{ formError }}</p>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showModal = false; resetForm();"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Danışman Ekle
            </b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal size="lg" v-model="editModal" title="Danışman Düzenle" hide-footer>
        <form @submit.prevent="handleEditSubmit" autocomplete="off">
          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label for="name">Danışman Adı</label>
                <input
                    id="name"
                    type="text"
                    v-model="editForm.name"
                    class="form-control"
                    placeholder="Danışman adı giriniz"
                    :class="{
                    'is-invalid': editSubmitted && $v.editForm.name.$error,
                  }"
                />
                <div
                    v-if="editSubmitted && !$v.editForm.name.required"
                    class="invalid-feedback"
                >
                  Danışman Adı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>




            <div class="col-6">
              <div class="mb-3">
                <label class="me-2" :class="{
                    'is-invalid': editSubmitted && $v.editForm.site.$error,
                  }">Site Seçiniz</label>
                <div class="checkbox-group">
                  <label v-for="site in sites" :key="site.id" class="me-3">
                    <input
                        type="checkbox"
                        :id="`site_${site.id}`"
                        :value="site.id"
                        v-model="editForm.site"
                        class="form-check-input"
                    />
                    <label :for="`site_${site.id}`" class="form-check-label ms-1">{{ site.name }}</label>
                  </label>

                </div>
                <div
                    v-if="editSubmitted && !$v.editForm.site.required"
                    class="invalid-feedback"
                >
                  Site seçilmesi gerekli bir alandır.
                </div>
              </div>
            </div>

            <div class="col-12 mb-2">
              <div class="mb-3"  :class="{
                    'is-invalid': editSubmitted && $v.editForm.description.$error,
                  }">
                <label for="description">Danışman Bilgileri</label>
                <quill-editor
                    v-model="editForm.description"
                    ref="quillEditor"
                    :options="quillOptions"
                ></quill-editor>
              </div>
              <div
                  v-if="editSubmitted && !$v.editForm.description.required"
                  class="invalid-feedback" style="margin-top:-6px"
              >
                Danışman Bilgileri girilmesi gerekli bir alandır.
              </div>
            </div>


            <div class="col-12">
              <div class="mb-3">
                <label for="image" class="form-label">Danışman Resmi</label>
                <input
                    type="file"
                    id="image"
                    @change="onEditImageChange"
                    accept="image/*"
                    class="form-control"
                />

                <div v-if="editForm.image" class="mt-2 text-center">
                  <img :src="editForm.image" alt="Mevcut Resim" style="max-width: 50%; max-height: 100px;"/>
                </div>
              </div>


            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="isActive" class="me-2">Durum</label>
                <input
                    id="isActive"
                    type="checkbox"
                    v-model="editForm.isActive"
                    class="form-check-input"
                />
              </div>
            </div>
            <div
                v-if="editFormError.length>0"
                class="text-danger d-flex justify-content-end"
            >
              <p>{{ editFormError }}</p>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="editModal = false"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Danışman Düzenle
            </b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal
          v-model="deleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu Danışmanı silmek istediğinize emin misiniz? Silinmiş Danışmanı geri alamazsınız.
              </p>
              <form @submit.prevent="handleDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
          v-model="noDeleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Silinemez !</h4>
              <p class="text-muted font-size-14 mb-4">
                Oturumunu açtığınız Siteyi silemezsiniz.
              </p>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}
.pill span {
  padding: 6px 12px 4px 12px;
}
</style>
